<div class="backdrop-box-details booking-travler-pop payment-pop-main" *ngIf="!isPaymentCompleted">
  <div
    class="modal fade show traveler-popup-div"
    bsModal
    tabindex="-1"
    role="dialog"
    aria-labelledby="dialog-nested-name1"
    style="display: block"
  >
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h4
            id="dialog-nested-name1"
            class="modal-title pull-left flight-detail-pop-title"
          >
          <div class="back-pop-btn" (click)="onBackClick()">
            <i class="fa-solid fa-angle-left me-0"></i>
          </div>
            <i class="fa-solid fa-plane"></i> {{ "Review & Book" | translate }}
          </h4>
          <button
            type="button"
            class="btn-close close pull-right"
            aria-label="Close"
            (click)="onClose()"
          >
            <span aria-hidden="true" class="visually-hidden">&times;</span>
          </button>
        </div>
        <div class="modal-body flight-trip-in-body">
          <div class="row loading-flight-details" *ngIf="!flightOfferDetail">
            <img src="/assets/image/circle-loading.gif" alt="">
            <h4>{{"Checking for best price" | translate}}</h4>
          </div>
          <!-- <div class="row loading-flight-details" *ngIf="bookingProcessStart">
            <img src="/assets/image/circle-loading.gif" alt="">
            <h4 *ngIf="!isBookingError">{{"Booking process in progress..." | translate}} </h4>
            <p *ngIf="isBookingError"> {{bookingResponse | json}} </p>
          </div> -->
          <div class="row" *ngIf="flightOfferDetail">
            <div class="col-md-12 col-lg-6">
              <div class="payment-opt-title">
                <h5 class="mb-4">{{'Review Booking' | translate}}</h5>
              </div>

              <!-- one-way summary -->
                <div class="flight-booking-ticket-ing one-way-flight-result-data" *ngIf="searchRequestType == 'one-way'">
                  <div class="next-trip-ticket">
                    <div class="flight-city-dtls d-flex align-items-center justify-content-center mb-3 px-4">
                      <div class="from-city-name-ticket">
                        <h4>{{ oneWaySummary?.fromAirport.code }}</h4>
                        <span>{{ oneWaySummary?.fromAirport.city_name }},
                          {{ oneWaySummary?.fromAirport.country_name }}</span>
                      </div>
                      <div class="airline-icon-dcs">
                        <div class="flight-major-dtls">
                          <h6>
                            <p>
                              {{ oneWaySummary?.departureDate | date : "dd" }}
                              {{ (oneWaySummary?.departureDate | date : "MMM") ?? 'MMM' | translate }}
                              {{ oneWaySummary?.departureDate | date : "yyyy"}}
                            </p>
                          </h6>
                        </div>
                        <div class="arrow"></div>
                        <span>
                          <img src="/assets/image/flight-going.png" width="22" alt="">
                        </span>
                        <h6>{{ "One way" | translate }}</h6>
                      </div>
                      <div class="to-city-name-ticket">
                        <h4>{{ oneWaySummary?.toAirport.code }}</h4>
                        <span>{{ oneWaySummary?.toAirport.city_name }},
                          {{ oneWaySummary?.toAirport.country_name }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- round-trip summary -->
                <div class="flight-booking-ticket-ing round-trip-flight-result-data" *ngIf="searchRequestType == 'round-trip'">
                  <div class="next-trip-ticket">
                    <div class="flight-city-dtls d-flex align-items-center justify-content-center mb-3 px-4">
                      <div class="from-city-name-ticket">
                        <h4>{{ roundTripSummary.departureFlight.fromAirport.code }}</h4>
                        <span>{{ roundTripSummary.departureFlight.fromAirport.city_name }},
                          {{
                          roundTripSummary.departureFlight.fromAirport.country_name
                          }}</span>
                      </div>
                      <div class="airline-icon-dcs">
                        <div class="flight-major-dtls">
                          <p>
                            {{ roundTripSummary?.departureFlight.departureDate | date : "dd" }}
                            {{ (roundTripSummary?.departureFlight.departureDate | date : "MMM") ?? 'MMM' | translate }}
                            {{ roundTripSummary?.departureFlight.departureDate | date : "yyyy"}} <br />
                            {{ "Departure" | translate }}
                          </p>
                          <p>
                            {{ roundTripSummary?.returnFlight.returnDate | date : "dd" }}
                            {{ (roundTripSummary?.returnFlight.returnDate | date : "MMM") ?? 'MMM' | translate }}
                            {{ roundTripSummary?.returnFlight.returnDate | date : "yyyy"}} <br />
                            {{ "Return" | translate }}
                          </p>
                        </div>
                        <div class="arrow return-flight"></div>
                        <span>
                          <img src="/assets/image/round-trip.png" alt="" />
                        </span>
                      </div>
                      <div class="to-city-name-ticket">
                        <h4>{{ roundTripSummary.departureFlight.toAirport.code }}</h4>
                        <span>{{ roundTripSummary.departureFlight.toAirport.city_name }},
                          {{
                          roundTripSummary.departureFlight.toAirport.country_name
                          }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- multi-city summary -->
                <div class="flight-booking-ticket-ing multi-trip-flight-result-data" *ngIf="searchRequestType == 'multi-city'">
                  <div class="next-trip-ticket">
                    <div class="flight-city-dtls d-flex align-items-center justify-content-center mb-3 px-4">
                      <div class="from-city-name-ticket">
                        <h4>{{ multiCitySummary.origins[0].originCode }}</h4>
                        <span>{{ multiCitySummary.origins[0].originData.city_name }},
                          {{
                          multiCitySummary.origins[0].originData.country_name
                          }}</span>
                      </div>
                      <div class="airline-icon-dcs">
                        <div class="flight-major-dtls multicity-via-dtls">
                          <h6>
                            Via
                            <p> <mark *ngFor="let point of multiCitySummary.points">{{point.city_name}},</mark> </p>
                          </h6>
                        </div>
                        <div class="arrow"></div>
                        <span>
                          <img src="/assets/image/round-trip.png" alt="" />
                        </span>
                      </div>
                      <div class="to-city-name-ticket">
                        <h4>{{ multiCitySummary.origins[multiCitySummary.origins.length - 1].destinationCode }}</h4>
                        <span>{{ multiCitySummary.origins[multiCitySummary.origins.length - 1].destinationData.city_name }},
                          {{
                          multiCitySummary.origins[multiCitySummary.origins.length - 1].destinationData.country_name
                          }}</span>
                      </div>
                    </div>
                  </div>
                </div>

              <div class="payment-opt-title mt-4">
                <h5 class="mb-4">{{'Travelers List' | translate}}</h5>
              </div>
              <div class="travelers-names-list">
                <ul>
                  <li *ngFor="let traveler of travellersData; let i = index">
                    <a
                        data-bs-toggle="collapse"
                        role="button"
                        [attr.aria-expanded]="selectedTraveler === i"
                        aria-controls="collapseExample"
                        (click)="toggleTravelerDetails(i)"
                      >
                      <span>{{ 'Traveler' | translate }} {{ i + 1 }}:</span> {{ traveler.title }} {{ traveler.firstName }} {{ traveler.lastName }} ({{ traveler.type | translate }})
                    </a>
                    <div [ngClass]="{ 'collapse show': selectedTraveler === i, 'collapse': selectedTraveler !== i }" [id]="'traveler' + i">
                      <div class="card card-body">
                        <table class="table mb-0">
                          <tbody>
                            <tr>
                              <th scope="row">{{ 'Full Name' | translate }}</th>
                              <td>{{ traveler.title }} {{ traveler.firstName }} {{ traveler.lastName }}</td>
                            </tr>
                            <tr>
                              <th scope="row">{{ 'Date Of Birth' | translate }}</th>
                              <td>{{ traveler.dob }}</td>
                            </tr>
                            <tr>
                              <th scope="row">{{ 'Nationality' | translate }}</th>
                              <td>{{ traveler.nationality }}</td>
                            </tr>
                            <tr>
                              <th scope="row">{{ 'Passport Number' | translate }}</th>
                              <td>{{ traveler.number }}</td>
                            </tr>
                            <tr>
                              <th scope="row">{{ 'Expiry Date' | translate }}</th>
                              <td>{{ traveler.expireDate }}</td>
                            </tr>
                            <tr>
                              <th scope="row">{{ 'Issue Country' | translate }}</th>
                              <td>{{ traveler.issuanceCountry }}</td>
                            </tr>
                            <!-- Add more traveler details here -->
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </li>
                </ul>

              </div>
              <div class="ticket-info-secs">
                <p>
                  {{'Tickets are non-transferable and name changes are not permitted. Total price shown includes all applicable taxes & fees and our service fees. Some airlines may charge additional baggage fees or other fees. Fares are not guaranteed until ticketed. Tickets and our fees are non-refundable (see Fare Rules). Some taxes and government agency fees may be non-refundable. Tickets can be cancelled for a fee, if requested within twenty-four (24) hours from the time of purchase. Date and routing changes will be subject to airline penalties and our fees.' | translate}}
                </p>
              </div>
              <div class="booking-contact-info-dtls">
                <div class="payment-opt-title">
                  <h5 class="mb-4">{{'Biling and Contact Information' | translate}}</h5>
                </div>
                <div class="book-flight-payments">
                  <div class="select-payment-method">
                    <div class="card-input-lists mt-3">
                      <form>
                        <div class="row gx-2">
                          <div class="col-md-6">
                            <div class="form-input">
                              <textarea [(ngModel)]="contactAddress1"
                                name=""
                                id=""
                                class="pt-2"
                                rows="10"
                                placeholder="{{'Address 1' | translate}}"
                              >{{contactAddress1}}</textarea>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-input">
                              <textarea [(ngModel)]="contactAddress2"
                                name=""
                                id=""
                                class="pt-2"
                                rows="10"
                                placeholder="{{'Address 2' | translate}}"
                              >{{contactAddress2}}</textarea>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-input">
                              <input type="text" [(ngModel)]="contactCountryName" placeholder="{{'Country' | translate}}" />
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-input">
                              <input type="text" [(ngModel)]="contactStateName" placeholder="{{'State' | translate}}" />
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-input">
                              <input type="text" [(ngModel)]="contactCityName" placeholder="{{'City' | translate}}" />
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-input">
                              <input type="text" [(ngModel)]="contactZipCode" placeholder="{{'Zip Code' | translate}}" />
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-input">
                              <input type="text" [(ngModel)]="contactEmail" placeholder="{{'E-mail ID' | translate}}" />
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-input">
                              <input
                              [(ngModel)]="contactNumber"
                                type="text"
                                placeholder="{{'Contact Phone' | translate}}"
                              />
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12 col-lg-6">
              <div class="payment-opt-title">
                <h5 class="mb-4">{{'Price Details' | translate}} (SAR)</h5>
              </div>
              <div class="trip-price-infos mt-0">
                <ul class="p-0 m-0">
                  <span class="fare-title">{{
                    "Fare Breakdown" | translate
                    }}</span>
                  <li *ngFor="let traveler of flightPriceByTraveller">
                    <a (click)="toggleTraveler(traveler)">
                      {{"Traveler" | translate}} {{traveler.travelerId}} ({{traveler.travelerType | titlecase}})
                      <i class="fa-solid fa-chevron-down"></i>
                    </a>
                    <span>{{ traveler.processedPrice.currency }} {{ traveler.processedPrice.totalFormated }}</span>
                    <div *ngIf="traveler.showPrice" class="per-traveler-price">
                      <div>
                        <span>{{ "Fare" | translate }}</span>
                        <span>{{ traveler.processedPrice.currency }} {{ traveler.processedPrice.baseFareFormated }}</span>
                      </div>
                      <div>
                        <span tooltip="Taxes & fees include service fees, as well as third party
                        taxes and surcharges such as airport tax, fuel surcharges
                        and airline fees. For more info, please view our T&Cs &
                        FAQs." [tooltipAnimation]="true" tooltipPlacement="top">{{ "Taxes & Fees" | translate }}
                          <i class="fa-solid fa-circle-info"></i></span><span>{{ traveler.processedPrice.currency }} {{traveler.processedPrice.taxTotalFormated }}</span>
                      </div>
                    </div>
                  </li>
                  <li>
                    <span
                      tooltip="We are constantly working on improving your booking experience and sourcing the best travel options. Our service fee helps us in providing you a seamless experience for all your travel booking needs"
                      [tooltipAnimation]="true" tooltipPlacement="top">{{ "Service Fee" | translate }}
                      <i class="fa-solid fa-circle-info"></i></span><span>{{flightOfferPriceDetail.currency}} {{flightOfferPriceDetail.serviceFee | currency:'':''}}</span>
                  </li>
                  <li>
                    <span tooltip="Rehlte applies VAT as per law. For more info, please
                    view our updated T&Cs & FAQs." [tooltipAnimation]="true" tooltipPlacement="top">{{ "Vat" |
                      translate }}
                      <i class="fa-solid fa-circle-info"></i></span><span>{{flightOfferPriceDetail.currency}} {{flightOfferPriceDetail.vat | currency:'':''}}</span>
                  </li>
                  <li class="final-amount-pay">
                    {{ "Total inclusive of tax" | translate }}
                    <span>{{flightOfferPriceDetail.currency}} {{flightOfferPriceDetail.grandTotal | currency:'':''}}</span>
                  </li>
                </ul>
              </div>
              <div class="select-payment-opt-txt">
                <div class="payment-opt-title">
                  <h5 class="mb-4">{{'Select Payment Method' | translate}}</h5>
                </div>
                <button class="pay-now-payment-btn" data-bs-toggle="modal" data-bs-dismiss="modal" data-bs-target="#finalwelcome" (click)="createBooking()">
                  {{'Continue to Pay' | translate}} <i class="fa-solid fa-shield-halved"></i>
                </button>
                <div class="book-flight-payments" *ngIf="isPaymentStart">
                  <div class="select-payment-method">
                    <form action="/flight/payment-process" class="paymentWidgets" data-brands="AMEX MADA MASTER VISA SADAD_VA TABBY STC_PAY"></form>
                  </div>
                </div>

                <p class="payment-fare-info-dtls">
                  {{'Your booking will be sent to your registered email address' | translate}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-thank-you-modal *ngIf="isPaymentCompleted"></app-thank-you-modal>

<!-- <app-flight-payment-process [bookingRequest]="bookingRequest" *ngIf="isPaymentStart"></app-flight-payment-process> -->
